// extracted by mini-css-extract-plugin
export var infoCard = "Card-module--info-card--2rakb";
export var infoCardActive = "Card-module--info-card--active--0Cza1";